module.exports = __webpack_public_path__ + "static/media/exhibition_big_img.68609cc4.jpg";